<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="admins"
      class="elevation-1"
      :loading="loading"
      :items-per-page="-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Administrátoři</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer>Výpis</v-spacer>
          <v-dialog
            v-model="dialog"
            max-width="650"
          >
            <template
              v-slot:activator="{ on, attrs }"
            >
              <v-btn
                @click="editedItem = defaultItem"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                Přidat administrátora
              </v-btn>
            </template>
          <AdminForm
            :item="editedItem"
            v-if="dialog"
            @data-saved="getAdmins"
          >
          </AdminForm>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editAdmin(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          class="mr-2"
          @click="toggleActive(item)"
        >
          {{item.active ? 'mdi-sleep' : 'mdi-sleep-off'}}
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="getAdmins">Reset</v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import AdminForm from '../../forms/admin/AdminForm'
export default {
  name: 'Admins',
  components: { AdminForm },
  data () {
    return {
      loading: true,
      dialog: false,
      editedItem: {},
      defaultItem: {
        id: null,
        firstName: '',
        email: '',
        active: false,
        roleId: null
      },
      headers: [
        { text: 'Název', value: 'firstName' },
        { text: 'Login', value: 'email' },
        { text: 'Oprávnění', value: 'permission' },
        { text: 'Akce', value: 'actions' }
      ],
      admins: []
    }
  },
  methods: {
    initialize () {
      this.getAdmins()
    },
    getAdmins () {
      this.loading = true
      this.admins = []
      this.dialog = false
      const roleNames = ['Superadministrátor', 'Administrátor', 'Operátor'];
      [1, 2, 3].forEach(role => {
        this.$http.get(`/admin/roles/${role}`)
          .then(response => {
            this.admins = this.admins
              .concat(this.keysToCamelCase(response.data))
              .map(admin => {
                admin.permission = roleNames[admin.roleId - 1]
                return admin
              })
            this.loading = false
          })
          .catch(err => console.log(err))
      })
    },
    editAdmin (admin) {
      this.editedItem = Object.assign({}, admin)
      this.dialog = true
    },
    toggleActive (admin) {
      admin.active = !admin.active
      this.$http.patch(`/admin/users/${admin.id}`, this.keysToSnakeCase(admin))
        .then(response => {
          this.getAdmins()
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  created () {
    this.initialize()
  }
}
</script>

<style scoped>

</style>
